import React from "react";
import { useParams } from "react-router-dom";
import useIsPhone from "features/files/use-is-phone";
import { usePresenceRailWidth } from "features/presence/use-presence-rail-width";
import { AssistantWidget } from "./assistant-widget";

/**
 * Anchors the assistant panel under the header, where its launcher now lives.
 * The right offset mirrors MiniChatContainer so it clears the presence rail
 * and never overlaps the mini-chat strip.
 */
export const AssistantContainer: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const isPhone = useIsPhone();
  const railWidth = usePresenceRailWidth(companyId);
  const panelOffset = isPhone ? 0 : railWidth + 16;

  return (
    <div
      data-testid="assistant-container"
      className="pointer-events-none fixed top-16 z-[401] flex flex-col items-end p-4 transition-[right] duration-200"
      style={{ right: `${panelOffset}px` }}
    >
      <AssistantWidget />
    </div>
  );
};

export default AssistantContainer;
